<template>
  <div id="favoritec">
    <Dialog ref="dialog" :config="config"> </Dialog>
    <div class="ohead">
      <div class="myInput">
        <i class="el-icon-search"></i>
        <input type="text" :placeholder="$fanyi('请输入关键词搜索')" v-model="form.keywords"
          @keydown.enter="getShopsList('search')" />
      </div>
      <button @click="getShopsList('search')">{{ $fanyi('搜索') }}</button>
    </div>
    <div class="tallys" v-if="tagLists.length > 0">
      <span :class="item.titleChecked ? 'active' : ''" @click="tabBtnClick(item)" v-for="(item, index) in tagLists"
        :key="index" :title="item.tag_name">{{ item.tag_name }}</span>
    </div>
    <div class="shops" v-if="!Nodata" v-loading="loading">
      <div class="shopsOpt" v-for="(shopDataitem, shopDataindex) in shopData" :key="shopDataindex">
        <div class="optLeft">
          <p class="shopName" :class="{ color: shopDataitem.note > 0 }"
            @click="toShopDetails(shopDataitem.shop_name, shopDataitem.shop_id)">
            <!-- @click="
            $fun.toPage('/shopGoods?shopName=' + shopDataitem.shop_name)
            " -->
            {{ $fanyi('店铺') }}: {{ shopDataitem.shop_name }}
          </p>
          <div class="remark">
            <el-input v-model="shopDataitem.note" :placeholder="$fanyi('请输入备注信息')"
              @change="changeNote(shopDataitem.id, shopDataitem.note)"></el-input>
          </div>
          <div class="btns">
            <span @click.stop="shopTagOpen(shopDataitem)" @mouseenter.stop="shopDataitem.leftpic = true; $forceUpdate()"
              @mouseleave.stop="shopDataitem.leftpic = false; $forceUpdate()">
              <img :src="shopDataitem.leftpic == true
                ? require('../../../../assets/newassets/collection/label2.svg')
                : require('../../../../assets/newassets/collection/label1.svg')
                " alt="" />
              {{ $fanyi('选择标签') }}
            </span>
            <span @click="delshop(shopDataindex, shopDataitem)"
              @mouseenter.stop="shopDataitem.rightpic = true; $forceUpdate()"
              @mouseleave.stop="shopDataitem.rightpic = false; $forceUpdate()">
              <img :src="shopDataitem.rightpic == true
                ? require('../../../../assets/newassets/collection/delete2.svg')
                : require('../../../../assets/newassets/collection/delete1.svg')
                " alt="" />
              {{ $fanyi('删除') }}
            </span>
          </div>
        </div>
        <div class="optRight">
          <div class="carouselBtn" @click="shopCarouselChange('left', shopDataindex)">
            <img src="../../../../assets/newassets/collection/left.svg" alt="" class="leftjaintou" />
          </div>

          <el-carousel ref="shopCarousel" trigger="click" height="120px" :autoplay="false" arrow="never"
            indicator-position="none">
            <el-carousel-item v-for="(goodsItem, goodsIndex) in shopDataitem.goods" :key="goodsIndex">
              <div class="optRightCon">
                <div class="shopGoods" v-for="(iu, sndex) in goodsItem.slice(0, 4)" :key="sndex" @click="
                  $fun.toCommodityDetails({
                    goods_id: iu.goods_id,
                    shop_type: iu.shop_type,
                    mi_id: iu.mi_id || '',
                  })
                  ">
                  <el-image :src="iu.imgUrl">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                    <div slot="placeholder">
                      <i class="el-icon-loading"></i>
                    </div>
                  </el-image>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="carouselBtn" @click="shopCarouselChange('right', shopDataindex)">
            <img src="../../../../assets/newassets/collection/right.svg" alt="" class="rightjiantou" />
          </div>
        </div>
      </div>
    </div>
    <!-- 没有商品 -->
    <div class="Nodata" v-else>

      <div class="NodataImg">
        <img src="../../../../assets/defaulticon/store.svg" alt="">
      </div>

      <div class="NodataText">

        {{ $fanyi('暂无店铺') }}
      </div>

    </div>
    <div class="allpag">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
        :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper" :page-size="10" :total="total">
      </el-pagination>
    </div>
    <div class="tagListEditContainer">
      <el-dialog :visible.sync="dialogVisible" width="640px" :show-close="false" :before-close="handleClose">
        <div class="tagListEditHeaderContainer flexAndCenter">
          <div>{{ $fanyi('选择标签') }}</div>
          <i class="el-icon-close" @click="dialogVisible = false"></i>
        </div>
        <div class="tagListEditCenterContainer">
          <div class="tagListEditCenterChildrenHeader flexAndCenter">
            <div class="addKeyWord flexAndCenter">
              <el-input :class="{ isChinese: isChinese }" :placeholder="$fanyi('请输入关键词')" v-model="addTagTxt"
                @keydown.enter="addTag">
                <template slot="append">
                  <div @click="addTag">
                    {{ $fanyi('新增') }}
                  </div>
                </template>
              </el-input>
            </div>
            <div class="removeTagBtn" @click="delTag()"> <img src="../../../../assets/newassets//collection/delete1.svg"
                alt="">
              {{ $fanyi('移除') }}
            </div>
          </div>
          <div class="tagListEditCenterChildrenFooter">
            <div v-for="(item, index) in tagLists" :key="index" class="flexAndCenter">
              <input type="checkbox" :checked="item.checked" @click="item.checked = !item.checked" name="" id=""
                class="che" /><span :title="item.tag_name">{{ item.tag_name }}</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer flexAndCenter">
          <el-button @click="saveTag">{{ $fanyi('确认') }}</el-button>
          <el-button type="primary" @click="dialogVisible = false">
            {{ $fanyi('取消') }}
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Dialog from '../../../../components/public/Dialog.vue'

export default {
  data() {
    return {
      Nodata: false,
      tagLists: [], //标签列表
      shopData: [], //收藏店铺列表
      addTagTxt: '', //添加标签的文本
      loading: false,
      leftpic: false,
      rightpic: false,
      total: 0,
      dialogVisible: false,
      goodsId: null,
      isChinese: localStorage.getItem('languagetype') == 'Chinese' ? true : false,
      form: {},
      config: {
        top: '20vh',
        width: '500px',
        title: this.$fanyi('提示'),
        btnTxt: [this.$fanyi('删除'), this.$fanyi('取消')],
      }, // 弹框属性
    }
  },
  components: {
    Dialog,
  },
  computed: {},
  created() {
    this.getTagData()
    this.form.pageSize = 5
    this.getShopsList('one')
  },
  mounted() {
    document.addEventListener('click', this.bodyCloseMenus)
  },
  methods: {
    // ***********************标签事件******************************************************
    // 添加标签
    addTag(item) {
      if (!this.addTagTxt) return false
      this.$api
        .favoriteTagAdd({
          type: 2,
          tag_name: this.addTagTxt,
        })
        .then((res) => {
          if (res.code != 0) return
          this.addTagTxt = ''
          // 重新获取标签列表
          this.$api.favoriteTagList({ type: '2' }).then((res) => {
            this.tagLists = res.data
            // 调用处理标签列表事件
            this.tagDataProcessing()
            this.shopTagOpen(item)
            this.$forceUpdate()
          })
        })
    },
    handleClose(done) {
      done()
    },
    // 将店铺分配到选中的标签里去
    saveTag() {
      let ids = []
      this.tagLists.forEach((item) => {
        if (item.checked) ids.push(item.tag_id)
      })
      ids = ids.join(',')
      let datas = {
        id: this.goodsId,
      }
      if (ids) {
        datas.tag_ids = ids
      } else {
        datas.tag_ids = ''
      }
      this.$api.favoriteShopToTags(datas).then((res) => {
        if (res.code != 0) return
        this.dialogVisible = false
      })
    },
    // 删除标签
    delTag() {

      this.tagLists.forEach((item, index) => {
        if (item.checked === true) {
          this.$api
            .favoriteTagDelete({
              tag_id: item.tag_id,
            })
            .then((res) => {
              if (res.code != 0) return
              this.tagLists.splice(index, 1)
            })
        }
      })
    },
    // 全局鼠标点击事件
    bodyCloseMenus() {
      // 关闭所有商品的标签弹窗
      this.shopData.forEach((item) => {
        item.showTagWin = false
      })
      this.$forceUpdate()
    },
    // 标签按钮点击事件
    tabBtnClick(item) {
      // 设置选中便签的值
      item.titleChecked = !item.titleChecked
      this.$forceUpdate()
      this.getShopsList('tagShops')
    },
    // 获取商品收藏夹标签列表并调用商品收藏夹列表获取函数
    getTagData() {
      this.$api.favoriteTagList({ type: '2' }).then((res) => {
        this.tagLists = res.data
        // 调用处理标签列表事件
        this.tagDataProcessing()
        // 调用获取商品收藏夹列表事件
      })
    },
    // 处理收藏夹标签数据
    tagDataProcessing() {
      this.tagLists.forEach((item) => {
        item.checked = false
        item.titleChecked = false
      })
    },
    // ******************商店事件*************************************************
    // 修改店铺备注
    changeNote(id, note) {
      this.$api
        .favoriteShopNoteSave({
          id: id,
          note: note,
        })
        .then((res) => {
          if (res.code != 0) return
        })
    },
    // 分页事件
    handleSizeChange(val) {
      this.form.page_num = val
      this.form.page = 1
      this.getShopsList('one')
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.getShopsList('one')
    },
    // 滑动店铺商品列表
    shopCarouselChange(type, index) {
      if (type == 'left') {
        this.$refs.shopCarousel[index].prev()
      } else if (type == 'right') {
        this.$refs.shopCarousel[index].next()
      }
    },
    // 获取店铺列表
    getShopsList(type) {
      this.loading = true
      let datas =
        type == 'search'
          ? {
            tag_ids: '',
            pageSize: this.form.pageSize,
            keywords: this.form.keywords,
          }
          : {
            tag_ids: '',
            page: this.form.page,
            pageSize: this.form.pageSize,
            keywords: this.form.keywords,
          }

      let tagIds = []
      this.tagLists.forEach((item) => {
        if (item.titleChecked) tagIds.push(item.tag_id)
      })
      tagIds = tagIds.join(',')
      datas.tag_ids = tagIds
      this.$api
        .favoriteShopList(datas)
        .then((res) => {
          this.loading = false
          if (!res.data.data || res.data.data.length == 0) {
            this.Nodata = true
          } else { this.Nodata = false }
          this.shopData = res.data.data
          this.total = res.data.total
          this.ProcessingShopData()
        })
        .catch((err) => { })
      this.ProcessingShopData()
    },
    //处理店铺数据
    ProcessingShopData() {
      this.shopData.forEach((item) => {
        let lack = 5 - (item.goods.length % 5) //取得店铺商品数离5个的倍数差多少个商品的数量

        //差多少个就从最前面取多少个填充到最后
        for (let i = 0; i < lack; i++) {
          item.goods.push(item.goods[i])
        }
        //  把单个店铺的商品分成五个一组
        item.goods = this.$fun.changeArr(item.goods, 5)
        item.showTagWin = false
      })

      this.$forceUpdate()
    },

    // 打开分配店铺标签窗口
    shopTagOpen(item) {
      this.goodsId = item.id
      let shopsTagIds = item.tag_ids.split(',')
      // 初始化商品标签列表数据
      this.tagLists.forEach((item) => {
        if (shopsTagIds.indexOf(String(item.tag_id)) != -1) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      this.dialogVisible = true
      this.$forceUpdate()
    },
    // 删除店铺
    delshop(index, item) {
      this.$refs.dialog.open(
        this.$fanyi('是否删除此店铺'),
        (cancel) => {
          this.$api.favoriteShopDelete({ id: item.id }).then((res) => {
            cancel()
            if (res.code != 0) {
              return
            }

            this.getShopsList()
          })
        },
        () => { }
      )
    },
    //跳转到店铺详情
    toShopDetails(name, id) {
      let url = window.location.origin
      window.open(`${url}/shopGoods?shopId=${id}&shopName=${name}`, '_blank')

    }
  },
}
</script>
<style lang="scss" scoped>
#favoritec {
  @import '../../../../css/mixin';

  width: 1060px;
  background: #ffffff;
  border-radius: 20px;
  padding: 30px 20px;
  padding-bottom: 10px;

  .ohead {
    display: flex;

    align-items: center;


    .myInput {
      width: 400px;
      height: 40px;
      border-radius: 12px;
      position: relative;
      display: flex;
      align-items: center;
      // overflow: hidden;
      margin-right: 20px;

      >i {
        width: 20px;
        height: 24px;
        margin: 9px 11px 9px 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #a2a2a2;
        position: absolute;
      }

      >input {
        border: 1px solid #e2e2e2;
        width: 100%;
        height: 100%;
        border-radius: 12px;
        font-size: 14px;
        padding-left: 40px;
        padding-right: 10px;
        transition: 0.3s;

        &:focus {
          border-color: #ff730b;
        }

        &::placeholder {
          color: #9a9a9a;
        }
      }
    }

    button {
      min-width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;

      height: 40px;
      background: #d12a1d;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      border-radius: 12px;
    }
  }

  .tallys {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 20px;

    span {

      height: 28px;
      background: #FAE9E8;
      border-radius: 8px;
      border: 1px solid #EDAAA5;

      font-weight: 400;
      padding: 0 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin-right: 10px;
      color: #222222;
      color: #D12A1D;
      margin-bottom: 10px;

      &:hover {
        cursor: pointer;
      }

      &.active {
        background: #D12A1D;
        border-radius: 8px;
        color: #FFFFFF;
        border: 1px solid #D12A1D;
      }
    }
  }

  .shops {
    width: 100%;
    min-height: 200px;
    margin-top: 10px;


    .shopsOpt {
      width: 100%;
      min-height: 180px;
      background: #ffffff;

      border-bottom: 0.5px solid #DFDFDF;
      padding: 30px 0px;

      display: flex;
      align-items: center;

      &:first-child {
        border-top: 1px solid #DFDFDF;
      }




      .optLeft {
        width: 360px;
        min-height: 120px;
        padding: 0 30px;


        .shopName {
          cursor: pointer;
          font-weight: normal;
          font-size: 16px;
          color: #121212;
          margin-bottom: 20px;
          white-space: nowrap;
          /* 强制文本不换行 */
          overflow: hidden;
          /* 隐藏溢出的内容 */
          text-overflow: ellipsis;
          /* 当文本溢出时显示省略号 */






        }



        .remark {
          /deep/.el-input {


            .el-input__inner {
              width: 300px;
              height: 38px;
              background: #FFFFFF;
              border-radius: 8px;
              border: 1px solid #DFDFDF;
            }
          }
        }

        .btns {
          margin-top: 20px;
          display: flex;
          justify-content: space-between;

          span {
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 14px;
            color: #999999;

            img {
              width: 14px;
              height: 14px;
              margin-right: 5px;



            }

            &:hover {
              color: #D12A1D;
              cursor: pointer;

              img {
                transform: scale(1.2);
              }
            }
          }
        }


      }

      .optRight {
        // margin: 20px 30px 0 20px;
        // 轮播图两侧样式
        width: 680px !important;
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        padding-right: 40px;

        .carouselBtn {
          width: 20px;
          cursor: pointer;
          // -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          display: flex;
          justify-content: center;
          align-items: center;



        }

        /deep/.el-carousel__arrow--right,
        /deep/.el-carousel__arrow--left {
          height: 0;
          overflow: hidden;
        }

        .el-carousel {
          width: 620px;
        }

        /deep/ .el-carousel__arrow {
          background: rgba(255, 255, 255, 0.5);

          i {
            color: $homePageSubjectColor;
          }
        }

        /deep/.el-carousel__button {
          width: 12px;
          height: 12px;
          background: #ffffff;
          border-radius: 50%;
        }

        /deep/.el-carousel__indicator.el-carousel__indicator--horizontal.is-active .el-carousel__button {
          background-color: transparent;
        }

        .optRightCon {
          width: 100%;
          height: 100%;
          display: flex;
          padding: 0 20px;
          justify-content: space-between;
          align-items: center;

          .shopGoods {
            cursor: pointer;

            /deep/.el-image {
              $imgSize: 120px;
              min-width: $imgSize;
              min-height: $imgSize;
              width: 120px;
              height: 120px;
              transition: 0.3s;
              display: flex;
              text-align: center;
              border-radius: 12px;

              i {
                font-size: $imgSize/5;
                line-height: $imgSize;
              }

              img {
                min-width: 120px;
                min-height: 120px;
                width: 120px;
                height: 120px;
              }
            }
          }
        }
      }
    }
  }

  .Nodata {
    display: flex;
    align-items: center;
    height: 320px;
    padding-top: 58px;
    flex-direction: column;

    .NodataImg {
      width: 160px;
      height: 160px;

      img {
        width: 100%;
        height: 100%;
      }


      margin-bottom: 30px;
    }

    .NodataText {
      font-weight: normal;
      font-size: 24px;
      color: #121212;
      line-height: 20px;
    }

  }

  .allpag {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0px;

    .el-pagination {
      display: flex;
      align-items: center;
    }

    >a {
      display: inline-block;
      border: 1px solid #dcdfe6;
      height: 28px;
      // background-color: white;
      text-align: center;
      padding: 0 10px;
      font-size: 13px;
      line-height: 28px;
      border-radius: 0;
    }

    /deep/.btn-prev {
      width: 30px;
      height: 30px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #DFDFDF;
      padding: 0;
      margin-right: 15px;
      margin-left: 20px;

      .el-icon {
        font-size: 16px;
        color: #000000;
      }
    }

    /deep/.btn-next {
      width: 30px;
      height: 30px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #DFDFDF;
      padding: 0;
      margin-left: 15px;



      .el-icon {
        font-size: 16px;
        color: #000000;
      }
    }

    /deep/ .el-pagination__jump {

      .el-input {
        width: 50px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 8px;
        margin-left: 5px;

        font-weight: 400;
        font-size: 14px;
        color: #000000;

        .el-input__inner {
          height: 30px;
          border-radius: 8px;
        }

      }
    }

    /* 分页被选中的页码样式 */
    /deep/ .el-pager li {
      margin: 0 5px;
      width: 30px;
      line-height: 30px;
      height: 30px;
      border-radius: 8px;
      // box-shadow: 0 0 6px 0 rgba(61, 61, 61, 0.1);

      &:hover {
        color: #D12A1D;
      }

      &.active {
        width: 30px;

        height: 30px;
        background: #D12A1D;
        line-height: 30px;
        color: #fff;
        border-radius: 8px;
      }
    }
  }

}

input[type='checkbox'] {
  background-color: #fff;
  -webkit-appearance: none;
  border: 1px solid #c0c4cc;
  border-radius: 6px;
  outline: none;
}

input[type='checkbox']:checked {
  background-color: #e40000;

  border: 1px solid #e40000;

  &::after {
    height: 4px;
    // 放大
    width: 9px;


  }
}

.tagListEditContainer {


  /deep/.el-dialog {
    width: 640px;

    background: #FFFFFF;
    border-radius: 20px;
  }

  /deep/ .el-dialog__header {
    display: none;
  }

  /deep/ .el-dialog__body {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /deep/ .el-dialog__header,
  /deep/ .el-dialog__body,
  /deep/.el-dialog__footer {
    padding: 0;
    border-radius: 10px;
  }

  .tagListEditHeaderContainer {
    height: 70px;
    padding-left: 40px;
    padding-right: 30px;
    box-sizing: border-box;
    align-items: flex-end;

    justify-content: space-between;

    div {
      font-weight: 600;
      font-size: 16px;
      color: #121212;
      line-height: 20px;
    }

    .el-icon-close {
      color: #000000;
      font-weight: bold;
      margin-bottom: 20px;
      font-size: 24px;
    }
  }

  .tagListEditCenterContainer {
    padding: 0 40px;
    padding-top: 30px;



    .tagListEditCenterChildrenHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .addKeyWord {
        width: 434px;
        height: 50px;

        .el-input {
          // width: 434px;
          height: 50px;
          background: #FFFFFF;
          border-radius: 12px;
          border: 1px solid #DFDFDF;

          display: flex;

          align-items: center;

          /deep/ .el-input__inner {
            flex: 3.2;
            // border: 1px solid #cdcdcd;
            // background: #fff2e8;
            border: 0 !important;
            border-right: none;
            // border-radius: 0;

          }



          /deep/.el-input-group__append {
            // max-width: 125px;
            height: 40px;
            flex: 1;
            background: #D12A1D;

            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 5px;
            border-radius: 10px;
            font-size: 14px;
            border: none;

            &:hover {
              cursor: pointer;
            }

            color: #FFFFFF;
          }
        }

        .isChinese {

          /deep/.el-input__inner {
            flex: 12;
            // border: 1px solid #cdcdcd;
            // background: #fff2e8;
            border: 0 !important;
            border-right: none;
            // border-radius: 0;

          }
        }
      }

      .removeTagBtn {
        width: 106px;
        height: 50px;
        background: #FFFFFF;
        border-radius: 12px;
        display: flex;
        align-items: center;

        img {
          margin-right: 10px;
        }

        &:hover {
          cursor: pointer;
        }

        justify-content: center;
        border: 1px solid #DFDFDF;
      }
    }

    .tagListEditCenterChildrenFooter {
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px;


      div {
        margin-bottom: 20px;
        margin-right: 40px;


        input[type='checkbox'] {
          width: 20px;
          height: 20px;
          border-radius: 6px;
          // border: 1px solid #cdcdcd;
        }

        span {
          display: inline-block;
          color: #222222;
          font-size: 14px;
          width: 120px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-left: 6px;
        }
      }
    }
  }

  .dialog-footer {
    height: 100px;
    padding: 30px 40px;
    justify-content: center;


    button:first-child {
      width: 120px;
      height: 40px;
      background: #D12A1D;
      border-radius: 10px;
      display: flex;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      align-items: center;
      justify-content: center;
      border: none;
      margin-right: 10px;

    }

    .el-button+.el-button {
      margin-left: 0;
    }

    button:last-child {
      width: 120px;
      height: 40px;
      background: #FFFFFF;
      font-weight: 400;
      font-size: 14px;
      color: #222222;
      border-radius: 10px;
      border: 1px solid #DFDFDF;
    }
  }
}
</style>
